import {
    WITHDRAWREQLISTFORPARTNER_SUCCESS,
    WITHDRAWREQLISTFORPARTNER_FAILED,
    RESET_WITHDRAWREQLISTFORPARTNER,
    LOADING_WITHDRAWREQLISTFORPARTNER,
    NETWORK_ERROR_WITHDRAWREQLISTFORPARTNER
} from "../types/index";

import { partnerServices } from "../../config/axios";


const resetWithdrawReqListForPartner = () => {
    return { type: RESET_WITHDRAWREQLISTFORPARTNER };
};

const partnerWithdrawReqList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_WITHDRAWREQLISTFORPARTNER });
    await partnerServices
        .post("withdrawReqListForPartner", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerWithdrawReqListsuccess(res.data));
                    break;
                default:
                    dispatch(partnerWithdrawReqListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_WITHDRAWREQLISTFORPARTNER,
                payload: err
            });
        });
};

function partnerWithdrawReqListsuccess(data) {
    return {
        type: WITHDRAWREQLISTFORPARTNER_SUCCESS,
        payload: data,
    };
}

function partnerWithdrawReqListFailed(data) {
    return {
        type: WITHDRAWREQLISTFORPARTNER_FAILED,
        payload: data,
    };
}

export { resetWithdrawReqListForPartner, partnerWithdrawReqList }